module.exports = __webpack_public_path__ + "img/lineone.3a1c77fb.jpg";